import Divider from '@cobliteam/ui/components/Divider';
import Skeleton from '@cobliteam/ui/components/Skeleton';
import Icon from '@cobliteam/ui/icons';
import { parseContent } from '../../../helpers';
import useSearch from '../../../hooks/useSearch';
import type { OramaIaWithCategory } from '../../../types';
const DOMAIN = 'https://suporte.cobli.co';

const ArticleIADetails = () => {
  const { selectedItem, category } = useSearch();
  if (!selectedItem) return null;

  const item = selectedItem as OramaIaWithCategory;
  const isLoading = selectedItem.category.loading || category.loading;
  const interaction = item?.interaction as any;

  const content = item.content.includes("I'm sorry") ? 'Não foi possível encontrar uma resposta para sua pergunta.' : item.content;

  return (
    <section className='col-span-9 flex h-[500px] flex-col gap-2 overflow-y-auto p-4' key={selectedItem?.id}>
      <div className='flex items-center gap-2 font-semibold text-base'>
        <Icon name={item.category.icon} className='size-4' />
        {item.category.name} {isLoading && <Icon name='loader-circle' className='size-3 animate-spin' />}
      </div>

      {isLoading ? (
        <div className='mt-4 flex flex-col gap-4'>
          {/* Question skeleton */}
          <Skeleton className='h-5 w-3/4 bg-gray-3' />

          {/* Content skeleton */}
          <div className='space-y-2'>
            <Skeleton className='h-4 w-full bg-gray-3' />
            <Skeleton className='h-4 w-full bg-gray-3' />
            <Skeleton className='h-4 w-3/4 bg-gray-3' />
          </div>

          {/* Related sources skeleton */}
          <div className='mt-4 space-y-2'>
            <Skeleton className='h-5 w-40 bg-gray-3' />
            <Skeleton className='h-px w-full bg-gray-3' /> {/* Divider skeleton */}
            <div className='space-y-2'>
              <Skeleton className='h-4 w-full bg-gray-3' />
              <Skeleton className='h-4 w-5/6 bg-gray-3' />
              <Skeleton className='h-4 w-4/6 bg-gray-3' />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className='font-medium text-sm'>Pergunta: {item.query}</div>
          <div className='whitespace-pre-wrap bg-gray-2 p-4 text-xs leading-relaxed'>{parseContent(content)}</div>
          {/* related sources */}
          {interaction?.sources?.length && (
            <>
              <div className='flex flex-col gap-2'>
                <div className='flex items-center gap-2 font-medium text-sm'>
                  <Icon name='search' className='size-3' />
                  Assuntos relacionados:
                </div>
                <Divider />
                <ul className='flex flex-col gap-2'>
                  {interaction.sources.map((source: { document: { id: string; title: string; path: string } }) => (
                    <li key={source.document.id} className='flex items-center text-xs'>
                      <div className='w-5'>
                        <Icon name='notepad-text' className='!size-3 mr-2' />
                      </div>
                      <a href={`${DOMAIN}${source.document.path}`} target='_blank' rel='noopener noreferrer' className='text-xs hover:text-primary hover:underline'>
                        {source.document.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default ArticleIADetails;
